import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-054c53cd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"display":"flex","flex-direction":"column","justify-content":"center","align-items":"center","padding":"20px"} }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"30px"} }, "请打开手机支付宝扫码支付", -1))
const _hoisted_3 = { style: {"width":"300px","height":"300px","background":"#999","margin-bottom":"30px"} }

import QRCode from 'qrcode';
import ScBtn from '@/components/common/widget/ScBtn.vue';
import { ref, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ZfbQr',
  props: {
    url: {}
  },
  setup(__props: any) {

const props = __props;

const qr = ref();

watch(
  [qr, props],
  () => {
    if (qr.value && props.url) {
      QRCode.toCanvas(qr.value, props.url, {
        width: 300,
        height: 300,
        margin: 4,
      });
    }
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("canvas", {
        ref_key: "qr",
        ref: qr
      }, null, 512)
    ]),
    _createVNode(ScBtn, {
      text: "我已完成支付",
      type: "primary"
    })
  ]))
}
}

})